import classNames from "classnames";
import { FieldState } from "formstate";
import { observer } from "mobx-react";
import React from "react";
import { TooltipComponent } from "../tooltipComponent";
import styles from "./form.css";

interface Props extends React.HTMLProps<HTMLInputElement> {
  type?: string;
  hasError?: boolean;
  errorHint?: string;
  inputRef?: (el?: HTMLInputElement) => void;
}
interface FieldStateProps extends React.HTMLProps<HTMLInputElement> {
  field: FieldState<string>;
}

/*
 *  Styled text input component with error feedback.
 *  Displays error message in a tooltip.
 *  TODO: implement proper ref forwarding
 */
export const EditInput = (props: Props) => {
  const { type, hasError, errorHint, className, inputRef, ...inputProps } = props;
  const propsClasses = className ? [className] : [];
  const errorClasses = hasError ? [styles["has-error"]] : [];
  return (
    <div className={classNames(styles["input-wrap"], propsClasses, errorClasses)}>
      <input
        type={type || "text"}
        ref={(el) => inputRef && inputRef(el || undefined)}
        {...inputProps}
      />
      {hasError && errorHint && (
        <div className={styles["error-feedback"]}>
          <TooltipComponent
            positionPreset={"top"}
            text={errorHint}
            width={"80px"}
            maxWidth={"1000%"}
            style={"error"}
            changeTransformTooltip={"translateX(-80%)"}
            changeTransformOutset={"translateX(300%)"}
          >
            <i className={classNames("icon-exclamation-mark")} />
          </TooltipComponent>
        </div>
      )}
    </div>
  );
};

export const EditInputFieldState = observer(({ field, className, ...rest }: FieldStateProps) => {
  const errorClasses = field.hasError ? [styles["has-error"]] : [];
  return (
    <div className={classNames(styles["input-wrap"], errorClasses, className)}>
      <input type="text" {...rest} onChange={(e) => field.reset(e.target.value)} value={field.$} />
      {field.hasError && field.error && (
        <div className={styles["error-feedback"]}>
          <TooltipComponent
            positionPreset={"top"}
            text={field.error}
            width={"80px"}
            maxWidth={"1000%"}
            style={"error"}
            changeTransformTooltip={"translateX(-80%)"}
            changeTransformOutset={"translateX(300%)"}
          >
            <i className={classNames("icon-exclamation-mark")} />
          </TooltipComponent>
        </div>
      )}
    </div>
  );
});
